import { useRef, useState } from "react";
import { InfMDFesInterface, infMunDescargaInterface, SelectObjectRemoveInterface } from "../../../../interfaces";
import { JConfirmDelete, MensagemModal } from "../../../../components/Components";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faPlus, faSave, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { addMDFe, removeMDFe, updateMDFe, updateNFe } from "../../../../features/manifestoSlice";
import { RootState } from "../../../../app/store";
import { formatMoeda, getUuidV4, handleNumberOnly, isNumber } from "../../../../utils/utils";
import { Link } from "react-router-dom";
import MDFesProdutoPerigoso from "./MDFesProdutoPerigoso";
import MDFesUnidadeTransp from "./MDFesUnidadeTransp";


const initialForm: InfMDFesInterface = {
    chMDFe: '',
    SegCodBarra: '',
    municipio_id: 0,
    name: '',
    indReentrega: false,
    peri: [],
    infUnidTransp: [],
    id: 0,

}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

const LIMITE: number = 10000;

const MDFes: React.FC = () => {
    const dispatch = useDispatch();
    const [notaManifesto, setNotaManifesto] = useState<InfMDFesInterface>(initialForm);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [showProdutoPerigoso, setShowProdutoPerigoso] = useState<boolean>(false);
    const [change, setChange] = useState<boolean>(false);
    const selectMunicipiosDescarregamento = useSelector((state: RootState) =>
        state.manifesto.selectMunicipiosDescarregamentos);
    const munDescarga = useSelector((state: RootState) => state.manifesto.manifesto.infMunDescarga);
    const munNFeSelectRef = useRef<HTMLSelectElement>(null);
    const manifesto = useSelector((state: RootState) => state.manifesto.manifesto);


    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleNFeChange = (e: any) => {
        const { name, value } = e.target;
        setNotaManifesto((prev) => ({ ...prev, [name]: value }))
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        if (change) {
            alerta('Existem alterações não salvas.');
            return;
        }
        setSelected(value);
        setShowModal(true);
    }

    const validaPreenchimentoMDFe = () => {
        if (notaManifesto.chMDFe === "") {
            alerta('Informe uma chave NFe.');
            return false;
        }

        if (!isNumber(notaManifesto.chMDFe)) {
            alerta('Chave MDF-e aceita somente números.');
            return false;
        }

        if (notaManifesto.SegCodBarra?.trim() !== "") {
            if (!isNumber(notaManifesto.SegCodBarra?.trim().toString())) {
                alerta('Seg. Cod. Barras aceita somente números.');
                return false;
            }
        }

        if (notaManifesto.chMDFe.substring(20, 22) !== '58') {
            alerta('Chave informada não é um MDF-e.');
            return false;
        }

        if (notaManifesto.chMDFe.length !== 44) {
            alerta('Chave deve conter 44 caracteres.');
            return false;
        }

        if (munDescarga.flatMap((item: infMunDescargaInterface) => item.infMDFe).find((item: InfMDFesInterface) =>
            item.chMDFe === notaManifesto.chMDFe && item.id !== notaManifesto.id)) {
            alerta('Chave já foi adicionada.');
            return false;
        }

        if (munDescarga.flatMap(item => item.infNFe).length >= LIMITE) {
            alerta(`Limite de ${formatMoeda(LIMITE, 0)} MDF-e atingido.`);
            return false;
        }

        setMessageAlert('')
        setShowAlert(false)
        return true;
    }

    const handleAdd = () => {

        if (munNFeSelectRef.current && munNFeSelectRef.current?.value !== "") {
            const nomeMunicipio = munNFeSelectRef.current?.options[munNFeSelectRef.current?.selectedIndex].text || ''

            if (validaPreenchimentoMDFe()) {

                console.log('form', notaManifesto);
                dispatch(addMDFe({
                    ...notaManifesto,
                    id: getUuidV4(),
                    name: nomeMunicipio,
                    municipio_id: parseInt(munNFeSelectRef.current?.value)
                }));

                setNotaManifesto(initialForm);
                setShowProdutoPerigoso(false);
            }

        } else {
            alerta("Selecione um município.");
            return;
        }
    }
    const handleRemover = (value: SelectObjectRemoveInterface) => {
        dispatch(removeMDFe({ municipio_id: parseInt(value.id.toString()), chMDFe: value.title }));
        setShowModal(false);
    }
    const loadNFe = (municipio_id: number, chMDFe: string) => {
        if (change) {
            alerta('Existem alterações não salvas.');
            return;
        } else {
            const municipio = manifesto.infMunDescarga.find((item: infMunDescargaInterface) => item.municipio_id === municipio_id);
            const mdfe = municipio?.infMDFe?.find((item: InfMDFesInterface) => item.chMDFe === chMDFe);
            setNotaManifesto({ ...notaManifesto, ...mdfe, municipio_id: municipio_id, name: municipio?.name });
            setChange(true);
            if (mdfe) {
                if (mdfe.peri?.length > 0) {
                    setShowProdutoPerigoso(true);
                }
            }
        }
    }

    const handleUpdateMDFe = () => {

        if (validaPreenchimentoMDFe()) {
            dispatch(updateMDFe({
                ...notaManifesto,
                name: munNFeSelectRef.current?.options[munNFeSelectRef.current?.selectedIndex].text || ''
            }));
            setNotaManifesto(initialForm);
            setChange(false);
            setShowProdutoPerigoso(false);
        }
    }

    return (<>
        <Row className="mb-3">
            <Col md>
                <Row className="g-2 mb-3">
                    <Col md={4}>
                        <Form.Group >
                            <Form.Label>*Municipios</Form.Label>
                            <Form.Select name="municipio_id"
                                value={notaManifesto.municipio_id}
                                onChange={handleNFeChange} ref={munNFeSelectRef}>
                                {selectMunicipiosDescarregamento?.map(item => {
                                    return (<option key={item.id} value={item.id}>{item.name}</option>);
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group >
                            <Form.Label>*Chave MDF-e</Form.Label>
                            <Form.Control name="chMDFe"
                                value={notaManifesto.chMDFe}
                                onKeyUp={handleNumberOnly}
                                type="text" maxLength={44}
                                onChange={handleNFeChange} />
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="g-2 mb-3">
                    <Col md>
                        <Form.Group >
                            <Form.Label>Seg. Cod. Barras</Form.Label>
                            <Form.Control name="SegCodBarra"
                                value={notaManifesto.SegCodBarra} maxLength={36}
                                onKeyUp={handleNumberOnly} type="text"
                                onChange={handleNFeChange} />
                        </Form.Group>
                    </Col>
                    <Col md={'auto'} className="d-flex align-items-end ">
                        <Form.Group controlId="active">
                            <Form.Switch className="mb-0" type="switch" name="active" label="ind. Reentrega?"
                                checked={notaManifesto.indReentrega}
                                onChange={(e) => setNotaManifesto({ ...notaManifesto, indReentrega: e.target.checked })}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={'auto'} className="d-flex align-items-end ">
                        <Form.Group controlId="active">
                            <Form.Switch className="mb-0" type="switch" name="opcoes" label="+Opções"
                                checked={showProdutoPerigoso}
                                title="Adicionar informações de produto perigoso e unidades de transporte"
                                onChange={(e) => setShowProdutoPerigoso(e.target.checked)} />
                        </Form.Group>
                    </Col>

                </Row>

                <Row className="g-2">
                    {change ? (<>
                        <Col md={'auto'} className="d-flex align-items-end">
                            <Button variant="success"
                                onClick={handleUpdateMDFe}
                            >
                                <FontAwesomeIcon icon={faSave} /> Salvar
                            </Button>
                        </Col>
                        <Col md={'auto'} className="d-flex align-items-end">
                            <Button variant="secondary"
                                onClick={() => {
                                    setChange(false);
                                    setShowProdutoPerigoso(false);
                                    setNotaManifesto(initialForm);
                                }}
                            >
                                <FontAwesomeIcon icon={faXmark} /> Cancalar
                            </Button>
                        </Col>
                    </>) : (
                        <Col md={'auto'} className="d-flex align-items-end">
                            <Button variant="primary"
                                onClick={handleAdd}
                            >
                                <FontAwesomeIcon icon={faPlus} /> Adicionar
                            </Button>
                        </Col>
                    )
                    }
                </Row>
            </Col>
            {showProdutoPerigoso && (

                <Col md={7} className="border-start">
                    <div className="nav nav-underline" id="v-pills-tab-produto-perigoso-mdfe" role="tablist">
                        <button className="nav-link active" id="tabpp1-tab-mdfe" data-bs-toggle="pill"
                            data-bs-target="#tabpp1-mdfe" type="button" role="tab"
                        >Produto Perigoso ONU (Opcional)</button>
                        <button className="nav-link" id="tabpp2-tab-mdfe" data-bs-toggle="pill" 
                            data-bs-target="#tabpp2-mdfe"
                            type="button" role="tab">Inf. Unidades de Transporte (Opcional)</button>

                    </div>
                    <div className="tab-content pt-2 px-2" id="v-pills-tabContentpp">
                        <div className="tab-pane fade show active" id="tabpp1-mdfe" role="tabpanel">
                            <MDFesProdutoPerigoso notaFiscal={notaManifesto} setNotaFiscal={setNotaManifesto} />
                        </div>
                        <div className="tab-pane fade" id="tabpp2-mdfe" role="tabpanel" >
                            <MDFesUnidadeTransp notaFiscal={notaManifesto} setNotaFiscal={setNotaManifesto}/>
                        </div>
                    </div>
                </Col>
            )}

        </Row>

        <h6 className=" my-3"><span className="text-dark">(10.000 no máximo)</span></h6>
        <Table striped bordered hover size="sm">
            <thead className="table-light">
                <tr>
                    <th className="text-center" style={{ width: '4rem' }}>#</th>
                    <th>Municipio</th>
                    <th>Chave NF-e</th>
                    <th>Seg. Cod. Barras</th>
                </tr>
            </thead>
            <tbody>
                {munDescarga?.map((item: infMunDescargaInterface) => (
                    <>
                        {item.infMDFe?.map((mdfe: InfMDFesInterface) => {
                            return (
                                <tr key={item?.municipio_id}>
                                    <td className="d-flex justify-content-around ">
                                        <Link to={''} className="text-danger"
                                            onClick={() =>
                                                handleOpenModal({ id: item.municipio_id, title: mdfe?.chMDFe })
                                            }
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </Link>
                                        <Link to={''} className="text-success" title="Editar"
                                            onClick={() =>
                                                loadNFe(item.municipio_id, mdfe?.chMDFe)
                                            }
                                        >
                                            <FontAwesomeIcon icon={faPencil} />
                                        </Link>

                                    </td>
                                    <td>{item.name}</td>
                                    <td>{mdfe.chMDFe}</td>
                                    <td>{mdfe?.SegCodBarra}</td>

                                </tr>
                            )
                        })}
                    </>
                ))}
            </tbody>
        </Table>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={selected.title}
            id={selected}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}

export default MDFes;